import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTable, Filter, FilterTag } from "../../../../../components";
import queryKey from "../../../../../enumerations/queryKey";
import agentStatusEnum from "../../enumerations/agentStatusEnum";
import { filterKeyBasicInfo } from "../../enumerations/filterKeyEnum";
import { filterSetupBasicInfo } from "../../enumerations/filterSetupEnum";
import { useGetSubordinateBasicInfo } from "../../hooks/subordinate.hooks";
const BasicInfo = () => {
  const { t } = useTranslation();
  const cache = useQueryClient();
  const basicInfoColumns = [
    {
      title: t("normal.account"),
      width: 130,
      dataIndex: "account",
      key: "account",
      align: "center",
    },
    {
      title: t("normal.uid"),
      width: 90,
      dataIndex: "account_id",
      key: "account_id",
      align: "center",
    },
    {
      title: t("subordinate.userBasicInfo.isAgent"),
      dataIndex: "role",
      key: "role",
      width: 150,
      align: "center",
      render: (text, record, index) => {
        const label = agentStatusEnum.find((item) => item.value === text).label;

        return <>{t(label)}</>;
      },
    },
    {
      title: t("normal.registrationTime"),
      dataIndex: "register_date",
      key: "register_date",
      width: 200,
      align: "center",
      render: (text, record, index) => <>{text === null ? "-" : text}</>,
    },
    {
      title: t("subordinate.userBasicInfo.reviewedTime"),
      dataIndex: "agent_reviewed_at",
      key: "agent_reviewed_at",
      width: 200,
      align: "center",
      render: (text, record, index) => <>{text === null ? "-" : text}</>,
    },
    {
      title: t("subordinate.userBasicInfo.lastLoggedInTime"),
      dataIndex: "login_date",
      key: "login_date",
      width: 200,
      align: "center",
      render: (text, record, index) => <>{text === null ? "-" : text}</>,
    },
  ];

  const [filterDefaultValue, setFilterDefaultValue] = useState({
    [filterKeyBasicInfo.ACCOUNT]: "",
    [filterKeyBasicInfo.ACCOUNT_ID]: "",
    [filterKeyBasicInfo.ROLE]: null,
    [filterKeyBasicInfo.REGISTER_START_DATE]: null,
    [filterKeyBasicInfo.REGISTER_END_DATE]: null,
    [filterKeyBasicInfo.AGENT_REVIEWED_START_DATE]: null,
    [filterKeyBasicInfo.AGENT_REVIEWED_END_DATE]: null,
  });
  const [filterValue, setFilterValue] = useState({
    [filterKeyBasicInfo.ACCOUNT]: "",
    [filterKeyBasicInfo.ACCOUNT_ID]: "",
    [filterKeyBasicInfo.ROLE]: null,
    [filterKeyBasicInfo.REGISTER_START_DATE]: null,
    [filterKeyBasicInfo.REGISTER_END_DATE]: null,
    [filterKeyBasicInfo.AGENT_REVIEWED_START_DATE]: null,
    [filterKeyBasicInfo.AGENT_REVIEWED_END_DATE]: null,
  });

  const [localData, setLocalData] = useState([]);

  const {
    data: basicInfoData,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    isLoading,
    isError,
  } = useGetSubordinateBasicInfo({
    params: {
      ...filterValue,
    },
    options: {
      getNextPageParam: (lastPage, pages) => {
        if (pages.length < lastPage.last_page) {
          return pages.length + 1;
        } else {
          return undefined;
        }
      },
    },
  });

  const loadMore = () => {
    if (isFetchingNextPage === false && localData.length > 0) {
      fetchNextPage();
    }
  };

  useEffect(() => {
    if (basicInfoData) {
      const page_length = basicInfoData.pages.length;
      if (page_length <= 1) {
        setLocalData([...basicInfoData.pages[0].data]);
      } else {
        setLocalData((prevState) => {
          return [...prevState, ...basicInfoData.pages[page_length - 1].data];
        });
      }
    }
  }, [basicInfoData]);

  const onHandleSearch = () => {};

  return (
    <div>
      <Filter
        filterSetup={filterSetupBasicInfo}
        filterDefaultValue={filterDefaultValue}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
        onReset={() => {
          //if need some aditional reset logic in the page
          console.debug("RESET FILTER");
        }}
        onSubmitSearch={onHandleSearch}
      />
      <FilterTag
        filterSetup={filterSetupBasicInfo}
        filterValue={filterValue}
        filterDefaultValue={filterDefaultValue}
        setFilterValue={setFilterValue}
        refreshSearch={onHandleSearch}
      />
      {isLoading ? (
        ""
      ) : isError ? (
        ""
      ) : (
        <CustomTable
          columns={basicInfoColumns}
          dataSource={localData}
          hasMore={hasNextPage}
          loadMore={loadMore}
          showInifineScroll={true}
        />
      )}
    </div>
  );
};

export default BasicInfo;
